import { useState } from 'react';
import clsx from 'clsx';

import { mediaUrl } from '@/features/chat/lib/media';

// Инициалы без фото: у каждого сотрудника свой цвет, чтобы в чате отличать на глаз.
const PALETTE = [
  'bg-orange/15 text-orange-700',
  'bg-amber-100 text-amber-800',
  'bg-emerald-100 text-emerald-800',
  'bg-sky-100 text-sky-800',
  'bg-violet-100 text-violet-800',
  'bg-rose-100 text-rose-800',
  'bg-teal-100 text-teal-800',
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}

export default function Avatar({
  name,
  url,
  size = 40,
  className,
}: {
  name: string;
  url?: string | null;
  size?: number;
  className?: string;
}) {
  const src = mediaUrl(url);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const box = { width: size, height: size };

  if (src && failedSrc !== src) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        onError={() => setFailedSrc(src)}
        className={clsx('shrink-0 rounded-full bg-paper object-cover', className)}
        style={box}
      />
    );
  }
  return (
    <span
      aria-hidden
      className={clsx(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold',
        PALETTE[hash(name) % PALETTE.length],
        className,
      )}
      style={{ ...box, fontSize: Math.round(size * 0.38) }}
    >
      {initials(name)}
    </span>
  );
}
